import PropTypes from "prop-types"

import { cn } from "styles/utils"

const ItemContainer = ({ className, ...props }) => {
  return <li className={cn("relative", className)} {...props} />
}

ItemContainer.propTypes = {
  className: PropTypes.string,
}

export default ItemContainer
